/*
 * @Description: 路由
 * @Date: 2025-06-11 19:13:08
 */
export const route = [
  {
    path: '/main/procurement-mgmt-list',
    name: 'procurement-mgmt-list',
    meta: {
      title: '服务采购管理'
    },
    component: () => import('../views/procurement-mgmt-list/index')
  },
  {
    path: '/main/procurement-mgmt-audit',
    name: 'procurement-mgmt-audit',
    meta: {
      title: '项目采购申请',
      parentPath: '/main/procurement-mgmt-list'
    },
    component: () => import('../views/procurement-mgmt-audit.vue')
  }
];
